import clsx from 'clsx'

const securityItems = [
  {
    title: '暗号化通信',
    description:
      '通信は SSL/TLS で常に暗号化されております（256bit暗号化）。通信における盗聴や傍受、改ざんやなりすましのリスクに対応しております。',
    breakLine: true
  },
  {
    title: '保存データの暗号化',
    description:
      'アップロードされたファイルは暗号化して保存されており（AES-GCMによる暗号化）、第三者によるデータの読み取りを防ぎます。'
  },
  {
    title: 'ファイアウォール',
    description:
      '外部のネットワークからの攻撃や不正なアクセスからデータの機密を保護するために、ファイアウォールにより機密情報をインターネットから隔離して保管しています。'
  },
  {
    title: 'バックアップ',
    description:
      '契約書データは常に自動バックアップしています。複数の施設にまたがる複数のデバイスにて多重にバックアップしているため災害時等でも紛失の心配がありません。'
  },
  {
    title: '機密保持ポリシー',
    description:
      'お客さまの同意を得たとき、または法令により要求される場合など、特定のごく限られた状況を除いて当社スタッフがお客さまの書類の内容やタイトル、取引先情報を閲覧することはございません。'
  },
  {
    title: 'アカウント保護',
    description:
      'パスワード設定時に短いパスワードや推測されやすいパスワードが登録できないようパスワード強度のチェックを行っております。またパスワード認証に加えてスマートフォンアプリで発行されるワンタイムパスワードを用いた2要素認証を設定することが可能です。'
  }
]

export function SecurityProtect() {
  return (
    <section>
      <div className="mx-auto px-6 xl:px-0 pt-16 pb-0 text-center lg:pt-32 lg:pb-0 lg:max-w-[960px]">
        <h2 className="text-lg font-bold text-textblack text-center lg:text-4xl font-feature-settings pb-0 lg:pb-6">
          ご安心ください
          <br />
          最新のセキュリティで
          <br />
          あなたの大切な情報を強固に守ります
        </h2>

        <div className="mt-6 flex flex-wrap justify-between lg:mt-14 gap-4 lg:gap-10">
          {securityItems.map((item, index) => (
            <div
              key={item.title}
              className="w-full border border-solid border-gray bg-white px-6 py-6 rounded-lg lg:px-12 lg:py-10 lg:w-[calc(50%-1.25rem)]"
            >
              <h3 className="text-xl font-bold text-primary text-center lg:text-2xl font-feature-settings">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-textblack text-left lg:text-base font-feature-settings lg:mt-3">
                {item.breakLine ? (
                  <>
                    通信は SSL/TLS で常に暗号化されております
                    <br className="hidden lg:block" />
                    （256bit暗号化）。
                    <br className="hidden lg:block" />
                    通信における盗聴や傍受、改ざんやなりすましのリスクに対応しております。
                  </>
                ) : (
                  item.description
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
